<template>
  <div class="section-wrapper" v-if="loaded">
    <div class="section-title">
      二. {{ entityJson.name }}
    </div>
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane :label="`${data.name}(${data.total})`" :name="key+''"
                   v-for="(data,key) in entityJson.data" :key="key">
        <div class="table">

          <template v-if="Array.isArray(data.data)">
            <div  v-for="(data2,key2) in data.data" :key="key2">
              <div class="tableTop">{{ data2.name }}（{{ data2.total }}）</div>
              <MoreTable :data="data2.data" ></MoreTable>
            </div>

          </template>
          <template v-else>
            <div class="tableTop">{{ data.name }}（{{ data.total }}）</div>
            <MoreTable :data="data.data"></MoreTable>
          </template>
        </div>
      </el-tab-pane>
      <el-tab-pane label="全部显示" :name="'-1'" :key="-1">
        <div class="table" v-for="(data,key) in entityJson.data" :key="key">
          <div class="tableTop"  v-if="!Array.isArray(data.data)">{{ data.name }}（{{ data.total }}）</div>
          <template v-if="Array.isArray(data.data)">
            <div v-for="(data2,key2) in data.data" :key="key2">
              <div class="tableTop">{{ data2.name }}（{{ data2.total }}）</div>
              <MoreTable :data="data2.data"  ></MoreTable>
            </div>

          </template>
          <template v-else>
            <MoreTable :data="data.data"></MoreTable>
          </template>
        </div>
      </el-tab-pane>
    </el-tabs>

  </div>
</template>

<script>
import MoreTable from "@/pages/Result/JinzhiReport/components/MoreTable";
import {getDueDiligenceModel002} from "@/api/api";
import OriginalTable from "@/pages/Result/JinzhiReport/components/OriginalTable";
import {getDesensitizationFromRouter} from "@/utils/helper";

export default {
  name: "PublicPositiveInformation",
  components: {
    MoreTable,
    OriginalTable
  },
  data() {
    return {
      activeName: '0',
      data: null,
      loaded: false
    };
  },
  async mounted() {
    this.loaded = false;
    const res = await getDueDiligenceModel002({uuid: this.$route.params.uuid,desensitizationStatus:getDesensitizationFromRouter()})
    this.data = res.data
    this.loaded = true
  },
  computed: {
    entityJson() {
      return this.data ? this.data.entityJson : {}
    }
  },
  methods: {
    handleClick(tab, event) {
      //console.log(tab, event);
    }
  }
}
</script>

<style lang="stylus" scoped>

</style>
